import { removeZipCodeFromAddress } from './removeZipCodeFromAddress';
import { shortenBuildingCorpus } from './shortenBuildingCorpus';
import { uppercaseSingleLetters } from './uppercaseSingleLetters';

const ADDRESS_SECONDARY_PART_REGEXP =
  /,\s?((((зон(а)?|эт(аж)?|пом(ещ)?(ение)?|в\/ч|воинская|офис|контора|кв\.?|квартира|ком\.?|комната)\s).*)|(промзона)$)/gi;

/**
 * Разделяет адрес на основную и второстепенную части для поиска в Dadata.
 *
 * В основную часть оставляет адрес, который лучше подходит для поиска подсказок:
 * удаляет почтовый индекс и сокращает "корпус" -> "к".
 *
 * Во второстепенную часть выносит уточнения, которые часто мешают поиску:
 * этаж, помещение, офис, квартиру, комнату или воинскую часть,
 * и нормализует их регистр.
 *
 * Примеры:
 * - "г. Москва, ул Ленина, д 10, кв. 15" -> ["г. Москва, ул Ленина, д 10", "кв. 15"]
 * - "123456, г. Самара, промзона" -> ["г. Самара", "промзона"]
 */
export const prepareAddressPartsForDadataSuggest = (addressString?: string) => {
  const normalizedAddress = addressString || '';
  const [mainPart = '', secondPart = ''] = normalizedAddress.split(ADDRESS_SECONDARY_PART_REGEXP);

  const preparedMainPart = removeZipCodeFromAddress(shortenBuildingCorpus(mainPart));
  const preparedSecondPart = uppercaseSingleLetters(secondPart.toLowerCase());

  return [preparedMainPart, preparedSecondPart] as const;
};
